export default {
  meta: {
    title: '开放页面-报价单'
  }
};
